import { render, staticRenderFns } from "./AlertFilters.vue?vue&type=template&id=38ff9d50&scoped=true"
import script from "./AlertFilters.vue?vue&type=script&lang=js"
export * from "./AlertFilters.vue?vue&type=script&lang=js"
import style0 from "./AlertFilters.vue?vue&type=style&index=0&id=38ff9d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff9d50",
  null
  
)

export default component.exports